import { Switch } from "@headlessui/react";
import { useController } from "react-hook-form";

export function Toggle({ leftLabel, rightLabel, name, control }) {
  const { field } = useController({ name, control });
  const enabled = field.value ?? false;

  return (
    <Switch.Group as="div" className="flex items-center">
      {leftLabel && (
        <Switch.Label
          as="span"
          className="mr-3 text-xs font-light text-gray-900"
        >
          {leftLabel}
        </Switch.Label>
      )}

      <Switch
        checked={enabled}
        onChange={field.onChange}
        name={field.name}
        className={`relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent
          ${enabled ? "bg-blue" : "bg-gray-200"}
          focus:outline-none focus:ring-2 focus:ring-blue focus:ring-offset-2`}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0
            ${enabled ? "translate-x-5" : "translate-x-0"}`}
        />
      </Switch>

      {rightLabel && (
        <Switch.Label
          as="span"
          className="ml-3 text-xs font-light text-gray-900"
        >
          {rightLabel}
        </Switch.Label>
      )}
    </Switch.Group>
  );
}
